import Button from 'components/Button';
import {
  BUTTON_TYPE_SUBMIT,
  BUTTON_TYPE_BUTTON,
} from 'shared/constants/common';

export default function DefaultActionButtons({
  secondaryButtonLabel = 'Cancel',
  primaryButtonLabel = 'Save changes',
  secondaryButtonClassName = '',
  primaryButtonClassName = '',
  onSecondaryButtonClick,
  onPrimaryButtonClick,
  secondaryButtonType = BUTTON_TYPE_BUTTON,
  primaryButtonType = BUTTON_TYPE_SUBMIT,
  containerClassName = '',
  isPrimaryButtonDisabled = false,
  isSecondaryButtonDisabled = false,
  hideSecondaryButton = false,
  hidePrimaryButton = false,
}) {
  const onSecondaryButtonClickHandler = () => {
    onSecondaryButtonClick?.();
  };

  const onPrimaryButtonClickHandler = () => {
    onPrimaryButtonClick?.();
  };

  return (
    <div className={`flex w-full justify-between ${containerClassName}`}>
      <div>
        {!hideSecondaryButton && (
          <Button
            secondary
            disabled={isSecondaryButtonDisabled}
            type={secondaryButtonType}
            onClick={onSecondaryButtonClickHandler}
          >
            <div className={secondaryButtonClassName}>
              {secondaryButtonLabel}
            </div>
          </Button>
        )}
      </div>
      {!hidePrimaryButton && (
        <Button
          disabled={isPrimaryButtonDisabled}
          type={primaryButtonType}
          onClick={onPrimaryButtonClickHandler}
        >
        <div className={primaryButtonClassName}>{primaryButtonLabel}</div>
      </Button>
      )}
    </div>
  );
}
